import { Box, Center, VStack, Heading } from '@chakra-ui/react';
import { useNavigate } from 'react-router';
import { MdLock } from 'react-icons/md';
import FaceliftButton from '@/components/Atoms/FaceliftButton/FaceliftButton';
import FaceliftText from '@/components/Atoms/FaceliftText/FaceliftText';

const Error401 = () => {
  const navigate = useNavigate();

  const handleGoToLogin = () => {
    navigate('/login');
  };

  return (
    <Center minH="100vh" bg="brand.pageBackground" px={{ base: 4, md: 8 }}>
      <VStack gap={4} maxW="500px" textAlign="center">
        {/* Error Code */}
        <Heading
          fontSize={{ base: '5xl', md: '6xl' }}
          fontWeight="bold"
          bg="brand.solidGradient"
          bgClip="text"
          lineHeight="1"
        >
          401
        </Heading>

        {/* Main Message with Icon */}
        <Box display="flex" alignItems="center" gap={3}>
          <Box
            width={{ base: '40px', md: '50px' }}
            height={{ base: '40px', md: '50px' }}
            borderRadius="full"
            bg="brand.solidGradient"
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexShrink={0}
          >
            <MdLock size={24} color="white" />
          </Box>
          <Heading
            fontSize={{ base: 'lg', md: 'xl' }}
            fontWeight="600"
            color="brand.textDark"
          >
            Unauthorized Access
          </Heading>
        </Box>

        {/* Subtitle */}
        <FaceliftText
          fontSize={{ base: 'sm', md: 'md' }}
          color="brand.textDark"
          opacity={0.7}
          maxW="400px"
        >
          You need to authenticate to access this page.
        </FaceliftText>

        {/* Action Button */}
        <FaceliftButton
          onClick={handleGoToLogin}
          size="sm"
          mt={2}
          _hover={{ opacity: 0.9 }}
        >
          Back to Login
        </FaceliftButton>
      </VStack>
    </Center>
  );
};

export default Error401;

